import React from 'react';
import _ from 'lodash'
import { Box, Card, CardContent, Typography, TextField, Grid, Button, InputAdornment, IconButton } from '@mui/material'
import { useRouteMatch } from 'react-router'
import { useHistory, Redirect } from "react-router-dom";
import { Container, Form, Spinner } from 'react-bootstrap'
import { useStyles as useStylesBase } from '../../constants/useStyles';
import ButtonLoading from '../../components/ButtonLoading';
import TextFieldValidate from '../../components/TextFieldValidate';
import { isEmail, validatePassword } from '../../utils/validator'
import config from '../../constants/config';
import { AxiosInstance } from '../../utils/RequestMethods';
import { getQueryStringParams } from '../../utils/utilsT';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useImmer } from 'use-immer';
import Validator from 'jsonschema'


var schema = {
  "id": "/formChangePassword",
  "type": "object",
  "properties": {
    "password": { "type": "string", "minLength": 8 },
    "confirmPassword": { "type": "string", "minLength": 8 },
  },
  "required": ["password", 'confirmPassword']
};

export interface ResetPasswordFieldsT {
  password: string
  confirmPassword: string
}
type ResetPasswordFieldsKeysT = keyof ResetPasswordFieldsT

export type IRestPasswordProps = {

}

interface RestPasswordParamsT {
  email: string
  // hash: string
  // code: string
  code: string
}

const initParams: RestPasswordParamsT = {
  email: null,
  code: null,
}

const ResetChangePassword: React.FC<IRestPasswordProps> = (props) => {
  const classesBase = useStylesBase()
  const [validated, setValidated] = React.useState(false);
  const [completedRequest, setCompletedRequest] = React.useState(false);

  const [fields, setFields] = useImmer({
    password: "",
    confirmPassword: "",
  });
  const [queryParams, setQueryParams] = React.useState(initParams);

  const [showPassword, setShowPassword] = React.useState(false)
  const [showConfirmPassword, setShowConfirmPassword] = React.useState(false)
  const [isReady, setIsReady] = React.useState(false);
  const [statusValidateCode, setStatusValidateCode] = React.useState<'none' | 'inValid' | 'valid'>("none");

  const validatorRef = React.useRef(new Validator.Validator())

  const match = useRouteMatch()
  const history = useHistory()


  React.useEffect(() => {

    const varQueryParams = getQueryStringParams(history.location.search)
    let params = { ...queryParams, ...varQueryParams }
    setQueryParams(params)
    initValidateCode(params)
  }, []);


  const initValidateCode = async (params: RestPasswordParamsT) => {
    let validateCode = await validateResetPasswordKey(params)
    if (validateCode) {
      setStatusValidateCode("valid")
    } else {
      setStatusValidateCode("inValid")
    }
  }

  const validateResetPasswordKey = async (params: RestPasswordParamsT): Promise<boolean> => {
    let paramsRequest = {
      email: params.email,
      code_pin: params.code,
      platform: "web",
    }
    try {
      let res = await AxiosInstance.post(`${config.url.token}/password/validate`, paramsRequest)
      if (res && res.data) {
        console.warn(res.data)
        return true;
      }
      return false
    } catch (error) {
      console.warn("error", error)
      return false;
    }
  }


  const onChangeField = (key: ResetPasswordFieldsKeysT, value: any): void => {
    setFields((draft) => {
      draft[key] = value
      // return draft
    })
  }




  const checkValidate = React.useCallback((params: ResetPasswordFieldsT) => {
    console.log("checkValidate", validatorRef)
    if (!validatorRef || !validatorRef.current) {
      return false
    }

    const valid = validatorRef.current.validate(params, schema)
    if (!valid.valid || !checkValidatePassword(params)) {
      return false
    }
    return true
  }, [fields]);


  const checkValidatePassword = React.useCallback((params: ResetPasswordFieldsT) => {
    if (params.password == "" || !validatePassword(params.password) || !matchPassword(params)) {
      return false
    }
    return true
  }, [fields]);



  const matchPassword = React.useCallback((params: ResetPasswordFieldsT) => {
    if (params.password != params.confirmPassword) {
      return false
    }
    return true
  }, [fields]);


  const submit = async (params): Promise<string> => {

    setValidated(true)

    if (!checkValidate(fields)) {
      throw new Error("Make sure to input correct password.")
    }

    try {

      let params = {
        email: queryParams.email,
        // hash: queryParams.hash,
        code_pin: queryParams.code,
        password: fields.password,
        confirm_password: fields.confirmPassword,
        platform: "web",
      }
      return await AxiosInstance.post(`${config.url.token}/password/reset`, params).then((res) => {
        if (res && res.data) {
          let msg = res.data.message ? res.data.message : "";
          // let data: UserT = res.data;
          setCompletedRequest(true)
        }
        return "Your password has been reset."
      })

    } catch (error) {
      throw new Error(error)
    }
  }


  if (completedRequest && queryParams.email != "") {
    return <Redirect to={`/login?email=${queryParams.email}`} />
  }

  if (statusValidateCode == "inValid") {
    return <Redirect to='/login' />
  }

  if (statusValidateCode == "none") {
    return (
      <Container className="" style={{ marginTop: "10vh" }}>
        <Box className=" d-flex  justify-content-center  align-item-center  mb-2">
          <Card className="  col-md-8">
            <CardContent>
              <Box className=" d-flex  justify-content-center align-item-center">
                <Spinner animation="border" variant="info" />
              </Box>
            </CardContent>
          </Card>
        </Box>
      </Container>
    )
  }

  return (
    <Container style={{ marginTop: "10vh" }}>
      <Box className=" d-flex  justify-content-center mb-2">
        <Card className="  col-md-8">
          <CardContent>

            <Form validated={validated} noValidate onSubmit={submit}

              style={{ padding: "20px" }}
            >
              <Typography variant='h5' className='mb-3' style={{}} >Change password</Typography>
              <Grid container spacing={3} className="mt-4">

                <Grid item xs={12}>
                  <TextFieldValidate

                    fullWidth

                    type={showPassword ? 'text' : 'password'}
                    value={`${fields.password}`}
                    required
                    // placeholder="Password"
                    onChange={(event: any) => {
                      let value = event.target.value
                      onChangeField("password", value)
                    }}
                    label="Password"
                    variant="standard"
                    InputProps={{

                      endAdornment: (<InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={(event) => {
                            event.preventDefault();
                          }}
                          onMouseDown={(e) => {
                            setShowPassword(!showPassword)
                          }}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>)
                    }}
                    onValidateError={(value) => {
                      if (value == "") {
                        return "Required"
                      }
                      if (!validatePassword(fields.password)) {
                        return "Your password must be at least 8 characters long, contain at least one number and have a mixture of uppercase and lowercase letters."
                      }
                      return ""
                    }}
                  />


                </Grid>

                <Grid item xs={12}>
                  <TextFieldValidate

                    fullWidth

                    type={showConfirmPassword ? 'text' : 'password'}
                    value={`${fields.confirmPassword}`}
                    required
                    // placeholder="Password"
                    onChange={(event: any) => {
                      let value = event.target.value
                      onChangeField("confirmPassword", value)
                    }}
                    label="Re-enter Password"
                    variant="standard"
                    InputProps={{
                      // disableUnderline: true,
                      endAdornment: (<InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={(event) => {
                            event.preventDefault();
                          }}
                          onMouseDown={(e) => {
                            setShowConfirmPassword(!showConfirmPassword)
                          }}
                          edge="end"
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>)
                    }}
                    onValidateError={(value) => {
                      if (value == "") {
                        return "Password is required."
                      }
                      if ((fields.password != "" && fields.confirmPassword != "" && !matchPassword(fields))) {
                        return "The passwords do not match."
                      }
                      return ""
                    }}
                  />


                </Grid>
                <Grid item xs={12}>

                  <ButtonLoading
                    customButton={Button}
                    customButtonProps={{
                      fullWidth: true,
                      variant: "contained",
                      color: "success",
                      size: "large"
                    }}

                    type="submit"
                    onClickFetching={async (e): Promise<string> => {
                      e.preventDefault()
                      return await submit(fields)
                    }}>
                    <Typography variant='h6' >Continue</Typography>
                  </ButtonLoading>
                </Grid>
              </Grid>
            </Form>
          </CardContent>
        </Card>
      </Box>
    </Container >
  );
}
export default ResetChangePassword
